function selectTab() {
    if ($(this).hasClass('disabled'))
        return;
    $(this).siblings().removeClass('selected');
    $(this).addClass('selected');
    $(this).parent().find('.tab-line').removeAttr('style');
}
module.exports = {
    select: selectTab
};
